var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import classNames from "classnames";
import Card from "./Card";
import ArrayUtils from "./util/array";
import { useEngine } from "./useEngine";
import { SettingsContext } from "./AppStateProvider";
var Cards = function (props) {
    var _a = React.useState(null), highlightedSuit = _a[0], setHighlightedSuit = _a[1];
    var _b = React.useState([]), selectedCardGroups = _b[0], setSelectedCardGroups = _b[1];
    var _c = React.useState([]), unselectedCardGroups = _c[0], setUnselectedCardGroups = _c[1];
    var _d = React.useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var hands = props.hands, selectedCards = props.selectedCards, notifyEmpty = props.notifyEmpty;
    var engine = useEngine();
    var _e = React.useContext(SettingsContext), separateCardsBySuit = _e.separateCardsBySuit, disableSuitHighlights = _e.disableSuitHighlights, reverseCardOrder = _e.reverseCardOrder;
    // Count how many copies of a card are currently available (unselected).
    var availableCountOf = function (card) {
        var _a;
        var total = props.playerId in hands.hands
            ? ((_a = hands.hands[props.playerId][card]) !== null && _a !== void 0 ? _a : 0)
            : 0;
        var selectedOfCard = (selectedCards !== null && selectedCards !== void 0 ? selectedCards : []).filter(function (c) { return c === card; }).length;
        return total - selectedOfCard;
    };
    // Track the last tapped card + time so a quick double-tap on touch devices
    // (which have no shift key) can select all remaining copies at once — the
    // touch equivalent of shift-click for grabbing pairs / tractor members.
    var lastTapRef = React.useRef(null);
    var handleSelect = function (card) { return function (event) {
        if (props.onCardClick !== undefined) {
            props.onCardClick(card);
        }
        if (selectedCards !== undefined && props.onSelect !== undefined) {
            // Shift-click (or shift+Enter) selects ALL remaining copies of this
            // card at once — a fast path for picking pairs / tractor members.
            var now = Date.now();
            var prevTap = lastTapRef.current;
            var isDoubleTap = prevTap !== null && prevTap.card === card && now - prevTap.time < 350;
            lastTapRef.current = { card: card, time: now };
            var selectAll = (event !== undefined && "shiftKey" in event && event.shiftKey) ||
                isDoubleTap;
            if (selectAll) {
                var toAdd = Array(Math.max(availableCountOf(card), 1)).fill(card);
                props.onSelect(__spreadArray(__spreadArray([], selectedCards, true), toAdd, true));
            }
            else {
                props.onSelect(__spreadArray(__spreadArray([], selectedCards, true), [card], false));
            }
        }
    }; };
    var handleUnselect = function (card) { return function () {
        if (selectedCards !== undefined) {
            var index = selectedCards.indexOf(card);
            if (index >= 0 && props.onSelect) {
                props.onSelect(ArrayUtils.minus(selectedCards, [card]));
            }
        }
    }; };
    var cardsInHand = props.playerId in hands.hands
        ? Object.entries(hands.hands[props.playerId]).flatMap(function (_a) {
            var c = _a[0], ct = _a[1];
            return Array(ct).fill(c);
        })
        : [];
    var unselected = selectedCards === undefined
        ? cardsInHand
        : ArrayUtils.minus(cardsInHand, selectedCards);
    // Create stable string representation of the player's hand for dependency checking
    // This prevents re-running the effect when hands.hands object reference changes
    // but the actual cards remain the same
    var handKey = React.useMemo(function () {
        if (!(props.playerId in hands.hands)) {
            return "";
        }
        // Create a stable key from the hand object (card -> count mapping)
        return Object.entries(hands.hands[props.playerId])
            .sort(function (_a, _b) {
            var a = _a[0];
            var b = _b[0];
            return a.localeCompare(b);
        })
            .map(function (_a) {
            var card = _a[0], count = _a[1];
            return "".concat(card, ":").concat(count);
        })
            .join(",");
    }, [hands.hands, props.playerId]);
    // Load sorted cards when they change
    React.useEffect(function () {
        setIsLoading(true);
        var loadSortedCards = function () { return __awaiter(void 0, void 0, void 0, function () {
            var selectedGroups, sorted, unselectedGroups, sorted, error_1, fallbackSelected, fallbackUnselected;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        selectedGroups = [];
                        if (!(props.selectedCards !== undefined &&
                            props.selectedCards.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, engine.sortAndGroupCards({
                                cards: props.selectedCards,
                                trump: props.trump,
                            })];
                    case 1:
                        sorted = _a.sent();
                        selectedGroups = sorted.map(function (g) {
                            return g.cards.map(function (c) { return ({
                                card: c,
                                suit: g.suit,
                            }); });
                        });
                        _a.label = 2;
                    case 2:
                        unselectedGroups = [];
                        if (!(unselected.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, engine.sortAndGroupCards({
                                cards: unselected,
                                trump: props.trump,
                            })];
                    case 3:
                        sorted = _a.sent();
                        unselectedGroups = sorted.map(function (g) {
                            return g.cards.map(function (c) { return ({
                                card: c,
                                suit: g.suit,
                            }); });
                        });
                        _a.label = 4;
                    case 4:
                        // Apply grouping settings
                        if (!separateCardsBySuit) {
                            selectedGroups =
                                selectedGroups.length > 0 ? [selectedGroups.flatMap(function (g) { return g; })] : [];
                            unselectedGroups =
                                unselectedGroups.length > 0
                                    ? [unselectedGroups.flatMap(function (g) { return g; })]
                                    : [];
                        }
                        if (reverseCardOrder) {
                            unselectedGroups.reverse();
                            unselectedGroups.forEach(function (g) { return g.reverse(); });
                        }
                        setSelectedCardGroups(selectedGroups);
                        setUnselectedCardGroups(unselectedGroups);
                        setIsLoading(false);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error("Error sorting cards:", error_1);
                        fallbackSelected = props.selectedCards
                            ? [props.selectedCards.map(function (c) { return ({ card: c, suit: null }); })]
                            : [];
                        fallbackUnselected = [
                            unselected.map(function (c) { return ({ card: c, suit: null }); }),
                        ];
                        setSelectedCardGroups(fallbackSelected);
                        setUnselectedCardGroups(fallbackUnselected);
                        setIsLoading(false);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        loadSortedCards();
    }, [
        props.selectedCards,
        props.trump,
        props.playerId,
        handKey, // Use the stable key instead of hands.hands
        separateCardsBySuit,
        reverseCardOrder,
        engine,
    ]);
    if (isLoading) {
        return (React.createElement("div", { className: "hand" },
            React.createElement("div", null, "Loading cards...")));
    }
    return (React.createElement("div", { className: "hand" },
        props.selectedCards !== undefined &&
            (props.selectedCards.length > 0 ||
                (notifyEmpty && unselectedCardGroups.length === 0)) ? (React.createElement("div", { className: "selected-cards" },
            selectedCardGroups.map(function (g, gidx) { return (React.createElement("div", { style: { display: "inline-block" }, key: gidx }, g.map(function (c, idx) { return (React.createElement(Card, { key: "".concat(gidx, "-").concat(idx), className: "selected", onClick: handleUnselect(c.card), trump: props.trump, card: c.card, collapseRight: idx !== g.length - 1 })); }))); }),
            props.selectedCards.length === 0 && (React.createElement(Card, { card: "\uD83C\uDCA0", trump: props.trump, className: classNames({ notify: notifyEmpty }) })))) : null,
        React.createElement("div", { className: classNames("unselected-cards", {
                unclickable: props.onSelect === undefined && props.onCardClick === undefined,
            }) },
            unselectedCardGroups.map(function (g, gidx) { return (React.createElement("div", { style: { display: "inline-block" }, key: gidx }, g.map(function (c, idx) { return (React.createElement(Card, { key: "".concat(gidx, "-").concat(idx), className: classNames(!disableSuitHighlights && highlightedSuit === c.suit
                    ? "highlighted"
                    : null), onClick: handleSelect(c.card), card: c.card, collapseRight: idx !== g.length - 1, trump: props.trump, onMouseEnter: function (_) { return setHighlightedSuit(c.suit); }, onMouseLeave: function (_) { return setHighlightedSuit(null); } })); }))); }),
            unselectedCardGroups.length === 0 && (React.createElement(Card, { trump: props.trump, card: "\uD83C\uDCA0" })))));
};
export default Cards;
